(function () {
  'use strict';

  angular
      .module('tf.retailer.Analytics')
      .factory('AnalyticsApi', AnalyticsApi);

  // @ngInject
  function AnalyticsApi($translate, Api) {

    return {
      getIntervals : getIntervals,
      getAllMetricData : getAllMetricData
    };

    function getIntervals() {
      return Api.get('/analytics/interval', { cache : true });
    }

    function getAllMetricData(tla, params) {
      return Api.get('/analytics/results/' + encodeURIComponent(tla), { params : params })
          .then(function (resultSet) {
            angular.forEach(resultSet, addMetricNames);
            return resultSet;
          });
    }

    function addMetricNames(metricData) {
      // add names here so d3 can use them (it doesn't have access to $translate
      addNames([metricData], 'metric');
      addNames(metricData.variations, 'variation', metricData);
      addNames(metricData.series, 'series', metricData);

      return metricData;
    }

    function addNames(objects, key, values) {
      _.each(objects, function (obj) {
        obj.name = $translate.instant(['analytics', key, obj[key]].join('.'), values);
      });
    }
  }

})();
